import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "tabs" };
var _hoisted_2 = { class: "channel-list" };
var _hoisted_3 = ["onClick"];
import { ref, computed } from 'vue';
import axios from 'axios';
import HomeVideoList from './home-video-list.vue';
import HomeSwipe from './home-swipe.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-channel',
    setup: function (__props) {
        var active = ref(0);
        var isShowPopup = ref(false);
        var list = ref([]);
        var currentChannelId = computed(function () {
            var _a;
            return ((_a = list.value[active.value]) === null || _a === void 0 ? void 0 : _a.id) || '0';
        });
        var handleTabChange = function (index) {
            active.value = index;
        };
        // 显示弹出层
        var showPopup = function () {
            isShowPopup.value = true;
        };
        // 切换频道
        var switchChannel = function (item) {
            var index = list.value.findIndex(function (channel) { return channel.id === item.id; });
            if (index !== -1) {
                active.value = index;
                isShowPopup.value = false;
            }
        };
        axios({
            url: '/navList',
            method: 'get'
        }).then(function (res) {
            list.value = res.data.result;
        });
        return function (_ctx, _cache) {
            var _component_van_tab = _resolveComponent("van-tab");
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_tabs = _resolveComponent("van-tabs");
            var _component_van_popup = _resolveComponent("van-popup");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_van_tabs, {
                        active: active.value,
                        "onUpdate:active": _cache[0] || (_cache[0] = function ($event) { return ((active).value = $event); }),
                        onChange: handleTabChange
                    }, {
                        default: _withCtx(function () { return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                                return (_openBlock(), _createBlock(_component_van_tab, {
                                    class: "van-tab",
                                    key: item.id,
                                    title: item.text
                                }, null, 8, ["title"]));
                            }), 128)),
                            _createElementVNode("div", {
                                class: "arrow-btn",
                                onClick: showPopup
                            }, [
                                _createVNode(_component_van_icon, { name: "arrow-down" })
                            ])
                        ]; }),
                        _: 1
                    }, 8, ["active"]),
                    _createVNode(_component_van_popup, {
                        show: isShowPopup.value,
                        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) { return ((isShowPopup).value = $event); }),
                        position: "bottom",
                        round: ""
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        class: _normalizeClass(["channel-item", { active: item.id === currentChannelId.value }]),
                                        onClick: function ($event) { return (switchChannel(item)); }
                                    }, _toDisplayString(item.text), 11, _hoisted_3));
                                }), 128))
                            ])
                        ]; }),
                        _: 1
                    }, 8, ["show"])
                ]),
                (currentChannelId.value === '0')
                    ? (_openBlock(), _createBlock(HomeSwipe, { key: 0 }))
                    : _createCommentVNode("", true),
                _createVNode(HomeVideoList, { channelId: currentChannelId.value }, null, 8, ["channelId"])
            ], 64));
        };
    }
});
